export default {
  nestedItem: Symbol('Nested Item'),
};
